import { DOCUMENT, Location } from '@angular/common';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '@core/api';
import { UserGroupService } from '@core/services/user-group.service';
import { environment } from '@environments/environment';
import { AppRoutes, ToasterHelper } from '@shared/helpers';
import { MessageService } from 'primeng/api';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export const globalHttpInterceptorFn: HttpInterceptorFn = (request, next) => {
    const accountRegisterUrl = environment.accountRegisterUrl;

    const messageService = inject(MessageService);
    const document = inject(DOCUMENT);
    const location = inject(Location);
    const apiService = inject(ApiService);
    const router = inject(Router);
    const userGroupService = inject(UserGroupService);

    const clonedRequest = request.clone({
        setHeaders: {
            'Cache-Control': 'no-cache',
            'X-Seq-GroupId': AppRoutes.seqGroupId.toString(),
        },
    });

    return next(clonedRequest).pipe(
        catchError((response: HttpErrorResponse) => {
            if (response?.headers?.has('X-Seq-GroupId-Redirect')) {
                const groupId = response.headers.get('X-Seq-GroupId-Redirect') || '';
                apiService.tearDown();
                userGroupService.forcedGroupChange(Number(groupId));

                return throwError(() => response);
            }

            if (response?.status === 403) {
                router.navigateByUrl(AppRoutes.routes().FORBIDDEN);
                apiService.tearDown();
                return throwError(() => response);
            }

            if (response?.status === 307) {
                const redirectUri = encodeURIComponent(`${window.location.origin}${location.path()}`);
                document.location.href = `${accountRegisterUrl}?redirectUri=${redirectUri}`;
                apiService.tearDown();
                return throwError(() => response);
            }

            messageService.add(ToasterHelper.error(response?.error?.message));
            return throwError(() => response);
        })
    );
};
